import { useState } from "react";
import { Menu, X, Gamepad2, Home } from "lucide-react";
import { Button } from "@/components/ui/button";

const LOGO_URL =
  "https://customer-assets-lxgj4vgw.emergentagent.net/job_silicom-pro-futbol/artifacts/bsulykak_Untitled%20Project%20-%20Artboard%201%20%281%29%20%281%29%20%281%29.png";

const links = [
  { label: "Inicio", href: "/#inicio" },
  { label: "Planes", href: "/#planes" },
  { label: "Cobertura", href: "/#cobertura" },
  { label: "Empresa", href: "/#empresa" },
  { label: "Contacto", href: "/#contacto" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-40 border-b border-slate-100 bg-white/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3">
        <a href="/" className="flex items-center gap-3" data-testid="nav-logo">
          <img
            src={LOGO_URL}
            alt="Silicomlan"
            className="h-14 w-auto md:h-16"
          />
        </a>

        <nav className="hidden items-center gap-7 text-sm font-medium text-slate-700 lg:flex">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              className="transition-colors hover:text-pink-500"
              data-testid={`nav-link-${l.label.toLowerCase()}`}
            >
              {l.label}
            </a>
          ))}
          <a
            href="/gaming"
            data-testid="nav-link-gaming"
            className="group inline-flex items-center gap-1.5 rounded-full border border-pink-200 bg-gradient-to-r from-pink-50 to-sky-50 px-3 py-1.5 text-xs font-black uppercase tracking-widest text-pink-600 transition-all hover:border-pink-400 hover:text-pink-700"
          >
            <Gamepad2 className="h-3.5 w-3.5" />
            Gaming
          </a>
          <a
            href="/#nexasmart"
            data-testid="nav-link-nexasmart"
            className="group inline-flex items-center gap-1.5 rounded-full border border-cyan-200 bg-gradient-to-r from-cyan-50 to-sky-50 px-3 py-1.5 text-xs font-black uppercase tracking-widest text-cyan-700 transition-all hover:border-cyan-400 hover:text-cyan-800"
          >
            <Home className="h-3.5 w-3.5" />
            NexaSmart
          </a>
        </nav>

        <div className="flex items-center gap-3">
          <Button
            data-testid="soy-cliente-btn"
            asChild
            className="hidden rounded-full bg-gradient-to-r from-pink-500 to-rose-500 font-bold text-white shadow-md shadow-pink-200 hover:from-pink-600 hover:to-rose-600 md:inline-flex"
          >
            <a
              href="https://silicomlan.ispcube.com"
              target="_blank"
              rel="noreferrer"
            >
              Soy Cliente
            </a>
          </Button>
          <button
            data-testid="mobile-menu-btn"
            onClick={() => setOpen(!open)}
            className="rounded-md p-2 text-slate-700 hover:bg-slate-100 lg:hidden"
            aria-label="Abrir menú"
          >
            {open ? <X className="h-5 w-5" /> : <Menu className="h-5 w-5" />}
          </button>
        </div>
      </div>

      {open && (
        <div className="border-t border-slate-100 bg-white px-6 py-4 lg:hidden" data-testid="mobile-menu">
          <div className="flex flex-col gap-3 text-sm text-slate-700">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="py-1 hover:text-pink-500"
              >
                {l.label}
              </a>
            ))}
            <a
              href="/gaming"
              data-testid="mobile-nav-gaming"
              onClick={() => setOpen(false)}
              className="inline-flex items-center gap-2 rounded-full border border-pink-200 bg-gradient-to-r from-pink-50 to-sky-50 px-3 py-2 text-xs font-black uppercase tracking-widest text-pink-600"
            >
              <Gamepad2 className="h-3.5 w-3.5" /> Gaming
            </a>
            <a
              href="/#nexasmart"
              data-testid="mobile-nav-nexasmart"
              onClick={() => setOpen(false)}
              className="inline-flex items-center gap-2 rounded-full border border-cyan-200 bg-gradient-to-r from-cyan-50 to-sky-50 px-3 py-2 text-xs font-black uppercase tracking-widest text-cyan-700"
            >
              <Home className="h-3.5 w-3.5" /> NexaSmart
            </a>
            <Button
              asChild
              className="mt-2 w-full rounded-full bg-gradient-to-r from-pink-500 to-rose-500 font-bold text-white"
            >
              <a
                href="https://silicomlan.ispcube.com"
                target="_blank"
                rel="noreferrer"
              >
                Soy Cliente
              </a>
            </Button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
